module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1TQ6U"))).then(() => parcelRequire('dJXJK'));